/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getsinfoanniversary2Inputs */

const de__field_getsinfoanniversary2 = /** @type {(inputs: _Field_Getsinfoanniversary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soll Jubiläumsinfo erhalten`)
};

/**

* @param {_Field_Getsinfoanniversary2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getsinfoanniversary2 = /** @type {((inputs?: _Field_Getsinfoanniversary2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getsinfoanniversary2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getsinfoanniversary2(inputs)
});
export { _field_getsinfoanniversary2 as "_field_getsInfoAnniversary" }